/* eslint-disable no-template-curly-in-string */
/* eslint-disable eqeqeq */
import html3pdf from 'html3pdf';
import esArray from './functionEsArray';

export const createPDF = async (informe) => {
  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };


  function formatTime(hours, minutes) {
    // Asegúrate de convertir hours y minutes a números
    const hoursNum = Number(hours);
    const minutesNum = Number(minutes);
    const totalMinutes = hoursNum * 60 + minutesNum;
    const finalHours = Math.floor(totalMinutes / 60);
    const finalMinutes = totalMinutes % 60;

    return `${finalHours} horas ${finalMinutes} minutos`;
  }




  const articulos =esArray(informe.articulos);
  const usuario_tecnico = articulos[0].tecnico.nombre;

  const htmlContent = `
  <html>
  <head>
    <style>
      body {
        font-family: Arial, sans-serif;
        margin: 20px;
      }
      h1, h2, h3, h4 {
        color: #333;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
      }
      th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: center;
        font-size: 10px;
      }
      th {
        background-color: #f2f2f2;
      }
      .label {
        display: inline-block;
        padding: 5px;
        color: white;
        border-radius: 3px;
      }
      .label-primary { background-color: #337ab7; }
      .label-warning { background-color: #f0ad4e; }
      .label-danger { background-color: #d9534f; }
      .label-success { background-color: #5cb85c; }
      img {
        max-width: 100px;
        max-height: 100px;
      }
      .centered {
        text-align: center;
      }
      .cover-page {
        display: flex;
        flex-direction: column;
        justify-content: top;
        align-items: center;
      }
      .cover-logo {
        max-width: 10000px;
        max-height: 10000px;
        height: 50px;
      }
      @page {
        margin: 20mm 20mm;
      }
      .page-break {
        page-break-before: always;
      }
      .hidden {
        display: none;
      }
      .page-break {
        page-break-before: always; /* Aquí se especifica el salto de página */
      }
      .header-table {
        width: 100%;
        border: none;
        margin-bottom: 20px;
      }

      .header-table td {
        border: none;
        vertical-align: middle;
      }

      .text-content {
        text-align: right;
        padding-left: 20px;
      }

      .text-content h3 {
        margin: 0;
        padding: 0;
        font-size: 15px;
      }

      .text-content h3:not(:last-child) {
        margin-bottom: 5px;
      }

      @page {
        margin: 15mm 15mm;
      }

      tr {
              page-break-inside: avoid;
      }
    </style>
  </head>
  <body>
    <table class="header-table">
          <tr>
            <td><img src="https://siam-srv.krakenlab.com.ar/static_content/img/CARTOCOR_LOGO.png" alt="Logo" class="cover-logo" /></td>
            <td class="text-content">
              <h3>Informe de Producción</h3>
            </td>
            <td class="text-content">
              <h3>Servicio de armado</h3>
            </td>
          </tr>
        </table>
     ${esArray(informe.articulos).map((articulo, index) => `
      <h4>Articulo N° ${index + 1} </h4>
      <table>
        <tr>
          <th>Número</th>
          <td>${informe.numero}</td>
          <th>Fecha</th>
          <td colspan="2">${formatDate(informe.fecha)}</td>
        </tr>
        <tr>
          <th>Cliente</th>
          <td>${informe.cliente.id_cuentas} - ${informe.cliente.nombre}</td>
          <th>Localización</th>
          <td>${informe.localizacion.id} - ${informe.localizacion.nombre}</td>
        </tr>
        <tr>
          <th>Nro Art.</th>
          <td>${articulo.articulo.alias}</td>
          <th>Desc. Art.</th>
          <td>${articulo.articulo.nombre}</td>
        </tr>
        <tr>
          <th>Maquina</th>
          <td>${informe.maquina.nombre}</td>
          <th>Componente</th>
          <td>${ informe.componente?.sin_valores === '1'
                  ? 'Componente no cargado'
                  : informe.componente?.nombre}</td>
        </tr>
        <tr>
          <th colspan="3">Técnico</th>
          <td colspan="5">${usuario_tecnico}</td>
        </tr>
        <tr>
          <th colspan="3">Orden Trabajo</th>
          <td colspan="5">${articulo?.orden_trabajo ? articulo?.orden_trabajo : ""}</td>
        </tr>
        <tr>
          <th colspan="3">Producción Total</th>
          <td colspan="5">${articulo?.produccion?.armado ? articulo?.produccion?.armado : articulo?.produccion?.cantidadIngresada}</td>
        </tr>
        <tr>
          <th colspan="3">Mermas Total</th>
          <td colspan="5">${articulo.mermas.total}</td>
        </tr>
        <tr>
          <th colspan="3">Cajas Aceptadas Total</th>
          <td colspan="5">${articulo?.produccion?.armado ? articulo?.produccion?.armado - articulo.mermas.total : articulo?.produccion?.cantidadIngresada - articulo.mermas.total}</td>
        </tr>
      </table>

      <h5>Mermas</h5>
      <table>
        <thead>
          <tr>
            <th>Proceso</th>
            <th>Detalle</th>
            <th>Valor</th>
            <th>Imagen</th>
          </tr>
        </thead>
        <tbody>
          ${Object.keys(articulo.mermas).map(proceso => `
            ${proceso !== 'total' ? `
              ${Object.keys(articulo.mermas[proceso]).map(detalle => `
                ${articulo.mermas[proceso][detalle].val == 0 ? '' : `
                  <tr>
                    <td>${proceso}</td>
                    <td>${detalle}</td>
                    <td>${articulo.mermas[proceso][detalle].val}</td>
                    <td>
                                ${
                                  articulo.mermas[proceso][detalle].pict &&
                                  typeof articulo.mermas[proceso][detalle]
                                    .pict === 'string'
                                    ? '<a href="' +
                                      articulo.mermas[proceso][detalle].pict +
                                      '" target="_blank">ver</a>'
                                    : '-'
                                }
                              </td>
                  </tr>
                `}
              `).join('')}
            ` : ''}
          `).join('')}
          <tr>
            <td colspan="2" style="text-align:center;"><strong>Total</strong></td>
            <td>${articulo.mermas.total}</td>
          </tr>
        </tbody>
      </table>

      <table>
        ${Array.isArray(informe.observaciones) ? informe.observaciones.map((obs, index) => `
          <tr>
            <th>Observación ${index + 1}</th>
            <td colspan="8">${obs.observaciones}</td>
          </tr>
        `).join('') : informe.observaciones ? `
          <tr>
            <th>Observación</th>
            <td colspan="8">${informe.observaciones.observaciones}</td>
          </tr>
        ` : `
          <tr>
            <th>Observación</th>
            <td colspan="8">Sin observación</td>
          </tr>
        `}
      </table>
    `).join('')}

    <div class="page-break">
      <h5>Totales Generales</h5>
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total Detenciones</td>
            <td>${ formatTime(informe.total_detenciones.horas, informe.total_detenciones.minutos)}</td>
          </tr>
          <tr>
            <td>Total Hotmelt</td>
            <td>${informe.total_hotmelt}</td>
          </tr>
          <tr>
            <td>Total Mermas</td>
            <td>${informe.total_mermas}</td>
          </tr>
          <tr>
            <td>Total Produccion</td>
            <td>${informe.total_produccion}</td>
          </tr>
          <tr>
            <td>Total Cajas Aceptadas</td>
            <td>${informe.total_produccion - informe.total_mermas}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </body>
  </html>
`;


  const opt = {
    margin: [15, 15, 15, 15],// Margen superior, derecho, inferior, izquierdo
    filename: `Informe_produccion_${informe.numero}.pdf`,
    image: { type: 'jpeg', quality: 1 },
    html2canvas: { scale: 2, logging: false, scrollX: 0, scrollY: -window.scrollY, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  };

  await html3pdf().from(htmlContent).set(opt).save();
};

export default createPDF;
